export default {"src":"/_next/static/media/base.d919fbef.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};